import { getOneXpExperiments } from 'src/universal/redux/oneXp';
import { getTermLinks } from 'service_modules/models/shared/cross-model-helper';
import { hasPznDataArrived } from 'src/universal/redux/pznData';
import {
  getExperimentalPageData,
  getPageCardsData,
  getPageData
} from 'src/universal/redux/page';
import { createSelector } from 'reselect';

export const tncKeys = ['offerTerms', 'ratesFees'];

export const isG169Variant = createSelector(
  [getOneXpExperiments],
  oneXpExperiments => {
    return (
      oneXpExperiments['GCS-169-VAC-Category-Optimization']?.dimensions[0]
        ?.variant === 'experiment'
    );
  }
);

export const getCombinedG169Data = createSelector(
  [
    isG169Variant,
    getExperimentalPageData,
    getPageCardsData,
    getPageData,
    hasPznDataArrived
  ],
  (g169Variant, { g169VacOptimization }, cardList, pageData, pznArrived) => {
    const cardObj = cardList.find(card => card.shortName === 'platinum');
    const termLinks = getTermLinks(cardObj.tncLinks, cardObj, {
      pageData: pageData
    });
    const tncLabels = tncKeys.map(txt => {
      const result = (pageData?.labels || []).find(label => {
        return label.identifier === txt;
      });
      return result?.text || '';
    });

    let tncInfo = null;

    if (pznArrived) {
      tncInfo = {
        termLinks,
        tncLabels
      };
    }

    return {
      isG169Variant: g169Variant,
      staticG169Data: g169VacOptimization,
      cardObj,
      tncInfo
    };
  }
);
